import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getPageTitle } from '@/utils/get-page-title'
import { getToken, setToken } from '@/utils/auth'
import Store from '@/store'
import { Message } from 'element-ui'

// 返回小程序页面
function backToMiniprogram() {
  const wx = require('@/utils/weixinSDK')
  setTimeout(() => {
    wx.miniProgram.reLaunch({
      url: '/pages/index-main/index-main'
    })
  }, 1000)
}

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/change-password'] // no redirect whitelist
const isEnvWeixin = navigator.userAgent.toLowerCase().includes('micromessenger')
// eslint-disable-next-line
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title, Store.state.app.appConfig.organization)

  if (isEnvWeixin) {
    if (from.name === 'AssessmentDetail') {
      Message.info('正在跳转回微信小程序...')
      backToMiniprogram()
      return
    }
  }

  if (to.path === '/login' && to.query.mp) {
    const urlData = JSON.parse(decodeURIComponent(to.query.mp))
    if (urlData.query) {
      urlData.query = JSON.parse(urlData.query)
    }
    setToken(urlData.token)
    Store.commit('user/SET_TOKEN', urlData.token)
    window.sessionStorage.setItem('source', urlData.source)
    Store.commit('app/CHANGE_SHOW_TYPE', urlData.type)
    setTimeout(() => {
      if (urlData.query) {
        next({ name: urlData.routerName, params: { id: urlData.id }, query: { type: urlData.query.type, special: urlData.query.special }})
        return
      }
      next({ name: urlData.routerName, params: { id: urlData.id }})
    }, 1000)
    return
  }

  // 确定用户是否已登录
  const hasToken = getToken()

  const source = window.sessionStorage.getItem('source')

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已登录，重定向到主页
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = Store.getters.name
      if (hasGetUserInfo || source === 'miniprogram') {
        next()
      } else {
        await Store.dispatch('user/resetToken')
        Message.error('Has Error')
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  } else {
    /* has no token*/
    await Store.dispatch('user/resetToken')
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
